import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

import { hasPermissionGuard } from "../../../core/guards";
import { handleRoutePermission } from "../../../core/guards/guards-util";
import { Constants } from "../../../shared/constants/constants";
import { PermissionAction } from "../../../shared/constants/enums";
import { ProjectsService } from "../../../shared/services";

export const projectTypeViewAccessGuard = (state: ActivatedRouteSnapshot) => {
  const projectType = state.params["projectType"];
  return getProjectPermissionGuard(projectType, PermissionAction.view);
};

export const projectTypeEditAccessGuard = (state: ActivatedRouteSnapshot) => {
  const projectType = state.params["projectType"];
  return getProjectPermissionGuard(projectType, PermissionAction.manage);
};

export const projectTypeCreateAccessGuard = (state: ActivatedRouteSnapshot) => {
  const projectType = state.params["projectType"];
  return getProjectPermissionGuard(projectType, PermissionAction.create);
};

const getProjectPermissionGuard = (projectType: string, permissionAction: PermissionAction) => {
  const projectsService = inject(ProjectsService);
  const router = inject(Router);

  const permissionId = projectsService.getPermission(projectsService.getProjectTypeId(projectType) ?? 0);

  if (!permissionId) {
    return router.createUrlTree(["/console/project"]);
  }

  return handleRoutePermission({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: permissionAction,
          objectTypeId: permissionId,
        },
      ],
    },
  });
};

export const viewSectorsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageSectorsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createSectorsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.NATIONAL_PROJECTS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const viewCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageCyclesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.TP_CYCLES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
